// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style_wrapper_2CsMF","startPage":"style_startPage_1s76z","files":"style_files_273jS","bottom":"style_bottom_2he1X","shield":"style_shield_1qjql"};